(function (d) {
  const modal = d.querySelector("#Modal-option-information");
  if (!modal) return;

  const modalWrapper = modal.querySelector(".option-information-wrapper");
  let blocks = null;
  let loading = null;

  const show = (handle) => {
    if (!blocks) return;
    blocks.forEach((block) => {
      block.classList.toggle("option-information-block--active", block.dataset.optionInformationType === handle);
    });
  };

  const load = () => {
    loading =
      loading ||
      fetch(window.location.pathname + "?section_id=async-option-information")
        .then((res) => res.text())
        .then((txt) => {
          const section = new DOMParser().parseFromString(txt, "text/html").querySelector("[data-async-content]");
          if (!section) throw new Error("no option information");
          modalWrapper.innerHTML = section.innerHTML;
          blocks = modal.querySelectorAll(".option-information-block");
        })
        .catch(() => {
          loading = null;
        });
    return loading;
  };

  // Delegated: a variant change re-renders the option groups, and with them these buttons.
  d.addEventListener("click", (event) => {
    const btn = event.target.closest && event.target.closest("drawer-control[data-product-option-handle]");
    if (!btn) return;
    const handle = btn.dataset.productOptionHandle;
    if (blocks) show(handle);
    else load().then(() => show(handle));
  });
})(document);
